export class Subject {
  constructor(
    public contact?: string,
    public discriminator?: string
  ) {
    this.contact = '';
    this.discriminator = '';
  }
}
